import { getFinalStatusEmoji } from "./ReportTabUtils";

const THIN = { style: "thin", color: { rgb: "B0BEC5" } };
const THIN_BORDER = { top: THIN, bottom: THIN, left: THIN, right: THIN };
const MEDIUM = { style: "medium", color: { rgb: "546E7A" } };
const MEDIUM_BORDER = { top: MEDIUM, bottom: MEDIUM, left: MEDIUM, right: MEDIUM };
 
 
// ─── Helper: style one cell ───────────────────────────────────────────────────
function _sc(ws, addr, style) {
  if (!ws[addr]) ws[addr] = { v: "", t: "s" };
  ws[addr].s = style;
}
 
// ─── Helper: style a range ────────────────────────────────────────────────────
function _sr(ws, r1, c1, r2, c2, style) {
  const XLS = window.XLSX;
  for (let r = r1; r <= r2; r++) {
    for (let c = c1; c <= c2; c++) {
      const addr = XLS.utils.encode_cell({ r, c });
      if (!ws[addr]) ws[addr] = { v: "", t: "s" };
      ws[addr].s = style;
    }
  }
}
 
 
// ════════════════════════════════════════════════════════════════════════════
// Sheet 1 builder
// ════════════════════════════════════════════════════════════════════════════
export function _buildDailyStatusSheet(XLS, wb, { clientName, clientShort, cases, dateStr, total, settled, inProcess, overdue }) {
  const aoa = [
    // R1 (idx 0) — Company header (merges with R2)
    ["CLAIMPRO SERVICES", ...Array(9).fill("")],
    // R2 (idx 1) — spacer (part of R1 merge)
    Array(20).fill(""),
    // R3 (idx 2) — subtitle
    ["Vehicle Insurance Claim Management & Recovery Services", ...Array(19).fill("")],
    // R4 (idx 3) — report title + date
    ["DAILY ACCIDENT CASE STATUS REPORT", ...Array(16).fill(""), `Date: ${dateStr}`, "", ""],
    // R5 (idx 4) — prepared by / to
    [`Prepared by: ClaimPro Operations Team`, "", "", "", `To: ${clientName} – Management`, ...Array(15).fill("")],
    // R6 (idx 5) — stats badges
    [
      `📋 TOTAL CASES:  ${total}`,  "", "",          // cols 0-2
      `✅ CLAIM SETTLED:  ${settled}`, "", "",        // cols 3-5
      `🔄 IN PROCESS:  ${inProcess}`, "", "",         // cols 6-8
      `⚠️ OVERDUE (>120d):  ${overdue}`, "", "",      // cols 9-11
      "", "", "", "", "", "", "", "",                  // cols 12-19 empty
    ],
    // R7 (idx 6) — spacer
    Array(20).fill(""),
    // R8 (idx 7) — column headers
    [ "SR\nNO.",
      "VEHICLE\nNUMBER",
      "CATEGORY",
      "MAKE /\nMODEL",
      "YEAR",
      "BODY\nTYPE",
      "PLACE OF\nACCIDENT",
      "DATE OF\nACCIDENT",
      "INSURANCE\nTYPE",
      "ROOT CAUSE",
      "BRIEF\nDESCRIPTION",
      "IDV\nVALUE",
      "WORKSHOP\nNAME",
      "WORKSHOP\nPLACE",
      "UPDATE\nAS ON",
      "ETA",
      "CLAIM\nSETTLED DATE",
      "DAYS\nLAPSED",
      "DETAILED UPDATE",
      "FINAL\nSTATUS",
    ],
    // Data rows
    ...cases.map((c, i) => {
      const doa = c.dateOfAccident
        ? new Date(c.dateOfAccident).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
        : "-";
      const eta = c.eta
        ? new Date(c.eta).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
        : "-";
      const claimSettledDate = c.claimSettledDate
        ? new Date(c.claimSettledDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
        : "-";
      return [
        i + 1,
        (c.vehicleNumber || "").toUpperCase(),
        (c.category || "MAJOR").toUpperCase(),
        (c.makeModel || c.make || "-").toUpperCase(),
        c.year || "-",
        (c.bodyType || "-").toUpperCase(),
        (c.placeOfAccident || "-").toUpperCase(),
        doa,
        (c.insuranceType || "-").toUpperCase(),
        (c.rootCause || "-").toUpperCase(),
        (c.briefDescription || "-").toUpperCase(),
        (c.idvValue || 0),
        (c.workshopName || "").toUpperCase(),
        (c.workshopPlace || "-").toUpperCase(),
        (c.updateAsOn || "-").toUpperCase(),
        eta,
        claimSettledDate,
        Number(c.daysLapsed) > 0 ? String(c.daysLapsed) : "-",
        (c.detailedUpdate || c.briefDescription || "-").toUpperCase(),
        getFinalStatusEmoji(c.finalStatus || c.autoStatus),
      ];
    }),
     Array(20).fill(""),
    // Footer
    [
      `This report is auto-generated by ClaimPro Operations System on ${dateStr}. For queries, contact: ops@claimpro.in  |  Confidential – For ${clientName} Internal Use Only`,
      ...Array(19).fill(""),
    ],
  ];
 
  const ws = XLS.utils.aoa_to_sheet(aoa);
 const blankRow  = 8 + cases.length;      // 0-indexed blank gap row
  const footerRow = 8 + cases.length + 1;  // 0-indexed footer row
 
  // Column widths
  ws["!cols"] = [
    { wch: 5 },   // SR NO.
    { wch: 14 },  // VEHICLE NUMBER
    { wch: 10 },  // CATEGORY
    { wch: 16 },  // MAKE / MODEL
    { wch: 6 },   // YEAR
    { wch: 10 },  // BODY TYPE
    { wch: 18 },  // PLACE OF ACCIDENT
    { wch: 13 },  // DATE OF ACCIDENT
    { wch: 14 },  // INSURANCE TYPE
    { wch: 24 },  // ROOT CAUSE
    { wch: 30 },  // BRIEF DESCRIPTION
    { wch: 12 },  // IDV VALUE
    { wch: 24 },  // WORKSHOP NAME
    { wch: 16 },  // WORKSHOP PLACE
    { wch: 14 },  // UPDATE AS ON
    { wch: 14 },  // ETA
    { wch: 16 },  // CLAIM SETTLED DATE
    { wch: 8 },   // DAYS LAPSED
    { wch: 42 },  // DETAILED UPDATE
    { wch: 12 },  // FINAL STATUS
  ];
 
  ws["!rows"] = [
    { hpt: 30 }, { hpt: 8 }, { hpt: 16 }, { hpt: 24 }, { hpt: 18 },
    { hpt: 30 }, { hpt: 6 }, { hpt: 32 },
    ...cases.map(() => ({ hpt: 42 })),
    { hpt: 10 },  // blank spacer
    { hpt: 20 },  // footer
  ];
 
 ws["!merges"] = [
  { s: { r: 0, c: 0  }, e: { r: 1, c: 19 } },   // R1+R2 company header
  { s: { r: 2, c: 0  }, e: { r: 2, c: 19 } },   // R3 subtitle
  { s: { r: 3, c: 0  }, e: { r: 3, c: 15 } },   // R4 report title
  { s: { r: 3, c: 16 }, e: { r: 3, c: 19 } },   // R4 date
  { s: { r: 4, c: 0  }, e: { r: 4, c: 3  } },   // R5 prepared by
  { s: { r: 4, c: 4  }, e: { r: 4, c: 19 } },   // R5 to: client
  { s: { r: 5, c: 0  }, e: { r: 5, c: 2  } },   // badge 1 (cols 0-2)
  { s: { r: 5, c: 3  }, e: { r: 5, c: 5  } },   // badge 2 (cols 3-5)
  { s: { r: 5, c: 6  }, e: { r: 5, c: 8  } },   // badge 3 (cols 6-8)
  { s: { r: 5, c: 9  }, e: { r: 5, c: 11 } },   // badge 4 (cols 9-11)
  { s: { r: footerRow, c: 0 }, e: { r: footerRow, c: 19 } },  // footer
];
 
  // ── Styles ──────────────────────────────────────────────────────────────────
  _sr(ws, 0, 0, 1, 19, {
    font: { bold: true, sz: 18, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "0D2137" } },
    alignment: { horizontal: "center", vertical: "center" },
  });
  _sr(ws, 2, 0, 2, 19, {
    font: { sz: 10, color: { rgb: "90CAF9" } },
    fill: { fgColor: { rgb: "0D2137" } },
    alignment: { horizontal: "center", vertical: "center" },
  });
  _sr(ws, 3, 0, 3, 16, {
    font: { bold: true, sz: 13, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1565C0" } },
    alignment: { horizontal: "left", vertical: "center" },
  });
  _sr(ws, 3, 7, 3, 19, {
    font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1565C0" } },
    alignment: { horizontal: "right", vertical: "center" },
  });
  _sr(ws, 4, 0, 4, 3, {
    font: { sz: 9, color: { rgb: "1A3A5C" } },
    fill: { fgColor: { rgb: "E8F4FD" } },
    alignment: { horizontal: "left", vertical: "center" },
  });
  _sr(ws, 4, 4, 4, 19, {
    font: { bold: true, sz: 9, color: { rgb: "1A3A5C" } },
    fill: { fgColor: { rgb: "E8F4FD" } },
    alignment: { horizontal: "right", vertical: "center" },
  });
 
  // Badges: 4 different bg colours
  const badgeFills = ["1A3A5C","1A3A5C","1A3A5C",   // badge 1 (cols 0-2)
  "1B5E20","1B5E20","1B5E20",   // badge 2 (cols 3-5)
  "E65100","E65100","E65100",   // badge 3 (cols 6-8)
  "B71C1C","B71C1C","B71C1C",   // badge 4 (cols 9-11)
  "FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF", // cols 12-19 empty];
  ];

  for (let c = 0; c < 20; c++) {
    const addr = XLS.utils.encode_cell({ r: 5, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
     if (c >= 12) {
    // Empty remainder — plain white
    ws[addr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };
      } else {
        ws[addr].s = {
          font: { bold: true, sz: 11, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: badgeFills[c] } },
          alignment: { horizontal: "center", vertical: "center" },
        };
      }
  }
 
  // Column headers with medium borders
  _sr(ws, 7, 0, 7, 19, {
    font: { bold: true, sz: 9, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "0D2137" } },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    border: MEDIUM_BORDER,
  });
 
  // ── Data rows: borders + bold vehicle number & current status ← FIX 1 & 2 ──
  cases.forEach((c, i) => {
    const rowIdx = 8 + i;
    const status    = (c.finalStatus || c.autoStatus || "").toUpperCase();
    const isSettled  = status.includes("SETTLED");
    const isCritical = status.includes("CRITICAL");
    const isOverdue  = status.includes("OVERDUE");
    const rowBg = isCritical || isOverdue ? "FDEDED" : isSettled ? "E8F5E9" : "FFFFFF";
 
    for (let col = 0; col < 20; col++) {
      const addr = XLS.utils.encode_cell({ r: rowIdx, c: col });
      if (!ws[addr]) ws[addr] = { v: "", t: "s" };
 
      // col 2 = VEHICLE NUMBER → bold
      // col 6 = CURRENT STATUS → bold
      const isBold = col === 1 || col === 14 || col === 19;
 
      let fontColor = "0D2137";
      if (col === 17) {
        const days = Number(c.daysLapsed) || 0;
        fontColor = days > 120 ? "C62828" : days > 60 ? "E65100" : "2E7D32";
      } else if (col === 19) {
        fontColor = isSettled ? "2E7D32" : isCritical ? "C62828" : isOverdue ? "F57F17" : "1565C0";
      }
 
      ws[addr].s = {
        font: { bold: isBold, sz: 9, color: { rgb: fontColor } },
        fill: { fgColor: { rgb: rowBg } },
        alignment: {
          horizontal: "center",
          vertical: "center",
          wrapText: true,
        },
        border: THIN_BORDER,  // ← FIX 2: borders on every cell
      };
    }
  });
 
  // Blank spacer (no border, white)
  for (let c = 0; c < 20; c++) {
    const addr = XLS.utils.encode_cell({ r: blankRow, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
    ws[addr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };
  }
 
  // Footer
  _sr(ws, footerRow, 0, footerRow, 19, {
    font: { sz: 8, italic: true, color: { rgb: "1565C0" } },
    fill: { fgColor: { rgb: "E8F4FD" } },
    alignment: { horizontal: "center", vertical: "center" },
  });
 
  XLS.utils.book_append_sheet(wb, ws, "Daily Status Report");
}

// ════════════════════════════════════════════════════════════════════════════
// Sheet 2 builder — Master Tracker (Ops)
// ════════════════════════════════════════════════════════════════════════════
export function _buildMasterTrackerSheet(XLS, wb, { clientName, cases, dateStr, settled }) {
    const headers = [
        "SR", "VEHICLE NO", "FLEET CENTRE", "CATEGORY", "MAKE & MODEL", "YEAR",
        "BODY TYPE", "ACCIDENT PLACE", "DATE OF ACCIDENT", "INS TYPE",
        "ROOT CAUSE", "BRIEF DESCRIPTION", "DAMAGE DETAILS",
        "ESTIMATE (₹)", "IDV VALUE (₹)", "WORKSHOP NAME", "WORKSHOP PLACE",
        "UPDATE AS ON", "ETA", "CLAIM SETTLED DATE", "DAYS LAPSED", "ON ROAD DATE",
        "EST FROM SERVICE CTR (₹)", "APPROVED BY SURVEYOR (₹)", "DEPRECIATION (₹)",
        "SALVAGE (₹)", "CONSUMABLE UNCOVERED (₹)", "PAID TO WORKSHOP (₹)", "CLAIM STATUS",
        "REPAIR AMT EX-GST (₹)", "EXTRA PAID (₹)", "RCVD FROM INSURER (₹)",
        "DATE OF RECEIPT", "REMARKS", "CLAIM AMT RCVD (₹)", "RECOVERY (₹)",
        "MATERIAL DAMAGE", "DRIVER INJURY", "3RD PARTY INJURY",
        "OTHER EXPENSES (₹)", "LY SRS", "LY P&L",
    ];
    const numCols = headers.length; // 42
    const aoa = [
        ["CLAIMPRO — ACCIDENT CASES MASTER TRACKER (OPERATIONS INTERNAL)", ...Array(numCols - 1).fill("")],
        // Row 1 — subtitle  
        [`Full case database with financial details · Last updated: ${dateStr} · CONFIDENTIAL — Ops Team Only`, ...Array(numCols - 1).fill("")],
        Array(numCols).fill(""),
   
    headers,  
    ...cases.map((c, i) => {
      const doa = c.dateOfAccident ? new Date(c.dateOfAccident) : null;
      return [
        i + 1,
        (c.vehicleNumber || "").toUpperCase(),
        c.fleetCentre || "",
        (c.category || "MAJOR").toUpperCase(),
        (c.makeModel || "").toUpperCase(),
        c.year || "",
        (c.bodyType || "").toUpperCase(),
        (c.placeOfAccident || "").toUpperCase(),
        doa,
        (c.insuranceType || "COMPREHENSIVE").toUpperCase(),
        (c.rootCause || "").toUpperCase(),
        (c.briefDescription || "").toUpperCase(),
        c.damageDetails || "",
        c.estimate || "",
        c.idvValue || "",
        (c.workshopName || "").toUpperCase(),
        (c.workshopPlace || "").toUpperCase(),
        (c.updateAsOn || c.currentStatus || "").toUpperCase(),
        c.eta ? new Date(c.eta) : "",
        c.claimSettledDate ? new Date(c.claimSettledDate) : "",
        Number(c.daysLapsed) || "",
        c.onRoadDate ? new Date(c.onRoadDate) : "",
        c.workshopEstimate || 0,
        c.approvedBySurveyor || 0,
        c.deprecation || 0,
        c.salvage || 0,
        c.consumable || 0,
        c.workshopPayment ||0,
        c.claimStatus || "",
        ...Array(12).fill(""),
      ];
    }),
    Array(numCols).fill(""), // blank separator before summary
  ];

  const ws = XLS.utils.aoa_to_sheet(aoa, { cellDates: true, dateNF: "DD-MMM-YYYY" });
  

  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: numCols - 1 } },
  ];

  ws["!cols"] = [
    5,14,12,9,18,6,12,18,14,20,
    28,32,16,12,12,20,18,14,12,16,
    10,14,14,14,12,10,14,14,14,10,
    14,14,24,14,12,14,14,12,12,8,8,14,
  ].map(wch => ({ wch }));

  ws["!rows"] = [
    { hpt: 36 }, { hpt: 20 }, { hpt: 6 }, { hpt: 28 },
    ...cases.map(() => ({ hpt: 40 })),
    { hpt: 8 },
  ];

  // ── FIX 1 cont: style only A1/A2 directly — no _sr across the merged range ──
  ws["A1"] = {
  v: "CLAIMPRO — ACCIDENT CASES MASTER TRACKER (OPERATIONS INTERNAL)",
  t: "s",
  s: {
    font: { bold: true, sz: 14, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "0D2137" } },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
  },
};
for (let c = 1; c < numCols; c++) {
  const addr = XLS.utils.encode_cell({ r: 0, c });
  ws[addr] = { v: "", t: "s", s: { fill: { fgColor: { rgb: "0D2137" } } } };
}

  ws["A2"] = {
  v: `Full case database with financial details · Last updated: ${dateStr} · CONFIDENTIAL — Ops Team Only`,
  t: "s",
  s: {
    font: { sz: 9, color: { rgb: "90CAF9" } },
    fill: { fgColor: { rgb: "1A3A5C" } },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
  },
};
for (let c = 1; c < numCols; c++) {
  const addr = XLS.utils.encode_cell({ r: 1, c });
  ws[addr] = { v: "", t: "s", s: { fill: { fgColor: { rgb: "1A3A5C" } } } };
}

  // Column headers row
  _sr(ws, 3, 0, 3, numCols - 1, {
    font: { bold: true, sz: 8, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1565C0" } },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    border: MEDIUM_BORDER,
  });

  // Data rows
  cases.forEach((_, i) => {
    const rowIdx = 4 + i;
    const bg = i % 2 === 0 ? "E3F0FC" : "FFFFFF";
    for (let c = 0; c < numCols; c++) {
      const addr = XLS.utils.encode_cell({ r: rowIdx, c });
      if (!ws[addr]) ws[addr] = { v: "", t: "s" };
      ws[addr].s = {
        font: { bold: c === 1 || c === 28, sz: 8, color: { rgb: "0D2137" } },
        fill: { fgColor: { rgb: bg } },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
        border: THIN_BORDER,
      };
    }
  });

  // ── Summary section ───────────────────────────────────────────────────────
  const totalCases = cases.length;
  const pending = totalCases - settled;
  const overdueCount = cases.filter(c =>
    Number(c.daysLapsed) > 120 && !/settled/i.test(c.finalStatus || c.autoStatus)
  ).length;
  const criticalCount = cases.filter(c =>
  Number(c.daysLapsed) > 180 && !/settled/i.test(c.finalStatus || c.autoStatus)
  ).length;

  const summaryStartRow = 5 + totalCases;

  ws["!rows"].push({ hpt: 22 }); // section header row
  ws["!rows"].push({ hpt: 20 }); // col headers row

  // ── Section header: spans cols 0–3 (A+B label + C count + D pct) ──────────
  ws["!merges"].push({ s: { r: summaryStartRow, c: 0 }, e: { r: summaryStartRow, c: 3 } });
  ws[XLS.utils.encode_cell({ r: summaryStartRow, c: 0 })] = {
    v: "📊  CASE SUMMARY", t: "s",
    s: {
      font: { bold: true, sz: 11, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "0D2137" } },
      alignment: { horizontal: "left", vertical: "center" },
    },
  };
  // ── FIX 4: white-fill from col 4 onward (not col 6) ──────────────────────
  for (let c = 4; c < numCols; c++) {
    const addr = XLS.utils.encode_cell({ r: summaryStartRow, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
    ws[addr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };
  }

  // ── Col headers: METRIC merges A+B (0–1), COUNT at C (2), % at D (3) ──────
  const colHdrRow = summaryStartRow + 1;
  // METRIC header — merged across cols 0+1
  ws["!merges"].push({ s: { r: colHdrRow, c: 0 }, e: { r: colHdrRow, c: 1 } });
  ws[XLS.utils.encode_cell({ r: colHdrRow, c: 0 })] = {
    v: "METRIC", t: "s",
    s: {
      font: { bold: true, sz: 9, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1A3A5C" } },
      alignment: { horizontal: "center", vertical: "center" },
      border: MEDIUM_BORDER,
    },
  };
  // COUNT header — col 2
  ws[XLS.utils.encode_cell({ r: colHdrRow, c: 2 })] = {
    v: "COUNT", t: "s",
    s: {
      font: { bold: true, sz: 9, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1A3A5C" } },
      alignment: { horizontal: "center", vertical: "center" },
      border: MEDIUM_BORDER,
    },
  };
  // % OF TOTAL header — col 3
  ws[XLS.utils.encode_cell({ r: colHdrRow, c: 3 })] = {
    v: "% OF TOTAL", t: "s",
    s: {
      font: { bold: true, sz: 9, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1A3A5C" } },
      alignment: { horizontal: "center", vertical: "center" },
      border: MEDIUM_BORDER,
    },
  };
  // ── FIX 2: white-fill starts at col 4, not col 3 (col 3 = % header) ──────
  for (let c = 4; c < numCols; c++) {
    const addr = XLS.utils.encode_cell({ r: colHdrRow, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
    ws[addr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };
  }

  // ── Summary data rows ─────────────────────────────────────────────────────
  const sumItems = [
    { label: "📋  Total Cases",       count: totalCases,    pct: "100%",                                                        bg: "0D2137", fg: "FFFFFF" },
    { label: "✅  Claim Settled",     count: settled,       pct: totalCases ? `${Math.round(settled / totalCases * 100)}%`       : "0%", bg: "1B5E20", fg: "FFFFFF" },
    { label: "🔄  In Process",        count: pending,       pct: totalCases ? `${Math.round(pending / totalCases * 100)}%`       : "0%", bg: "E65100", fg: "FFFFFF" },
    { label: "⚠️  Overdue (>120d)",  count: overdueCount,  pct: totalCases ? `${Math.round(overdueCount / totalCases * 100)}%`  : "0%", bg: "B71C1C", fg: "FFFFFF" },
    { label: "🔴  Critical (>180d)", count: criticalCount, pct: totalCases ? `${Math.round(criticalCount / totalCases * 100)}%` : "0%", bg: "7B1FA2", fg: "FFFFFF" },
  ];

  sumItems.forEach((item, si) => {
    const rowIdx = colHdrRow + 1 + si;
    ws["!rows"].push({ hpt: 22 });

    // Label merges A+B (cols 0–1)
    ws["!merges"].push({ s: { r: rowIdx, c: 0 }, e: { r: rowIdx, c: 1 } });

    const cellStyle = (extra = {}) => ({
      fill: { fgColor: { rgb: item.bg } },
      font: { sz: 9, color: { rgb: item.fg }, ...extra },
      border: THIN_BORDER,
    });

    // Label → col 0 (spans 0+1 via merge, col 1 must be absent/empty)
    ws[XLS.utils.encode_cell({ r: rowIdx, c: 0 })] = {
      v: item.label, t: "s",
      s: { ...cellStyle({ bold: true }), alignment: { horizontal: "left", vertical: "center" } },
    };
    // ── FIX 3: COUNT → col 2, not col 1 (col 1 is inside the label merge) ──
    ws[XLS.utils.encode_cell({ r: rowIdx, c: 2 })] = {
      v: item.count, t: "n",
      s: { ...cellStyle({ bold: true, sz: 12 }), alignment: { horizontal: "center", vertical: "center" } },
    };
    // % → col 3
    ws[XLS.utils.encode_cell({ r: rowIdx, c: 3 })] = {
      v: item.pct, t: "s",
      s: { ...cellStyle(), alignment: { horizontal: "center", vertical: "center" } },
    };
    // White fill from col 4 onward
    for (let c = 4; c < numCols; c++) {
      const addr = XLS.utils.encode_cell({ r: rowIdx, c });
      if (!ws[addr]) ws[addr] = { v: "", t: "s" };
      ws[addr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };
    }
  });

  const lastRow = colHdrRow + sumItems.length;
  ws["!ref"] = XLS.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: lastRow, c: numCols - 1 } });

  XLS.utils.book_append_sheet(wb, ws, "Master Tracker (Ops)");
}
 
 
// ════════════════════════════════════════════════════════════════════════════
// Sheet 3 builder — Summary Dashboard
// ════════════════════════════════════════════════════════════════════════════
export function _buildSummaryDashboardSheet(XLS, wb, {
  clientName, cases, dateStr,
  total, settled, inProcess, overdue,
  settlePct, avgDays, totalIdvStr, activeWorkshops,
}) {
  // Category breakdown
  const catCount = {};
  cases.forEach(c => {
    const cat = (c.category || "MAJOR").toUpperCase().replace("MOJOR", "MAJOR");
    catCount[cat] = (catCount[cat] || 0) + 1;
  });
  const catRows = Object.entries(catCount).sort((a, b) => b[1] - a[1]);

  // Status breakdown
  const statusCount = {};
  cases.forEach(c => {
    const s = c.currentStatus || c.updateAsOn || (c.autoStatus === "SETTLED" ? "Claim Settled" : c.autoStatus);
    if (s) statusCount[s] = (statusCount[s] || 0) + 1;
  });
  const statusRows = Object.entries(statusCount).sort((a, b) => b[1] - a[1]);

  const numDataRows = Math.max(catRows.length, statusRows.length);
  const insightBase = 11 + numDataRows; // R0-R7=8 rows, R8 section hdr, R9 sub-hdr, R10+ data

  const aoa = [
    // R0: title
    ["CLAIMPRO — EXECUTIVE SUMMARY DASHBOARD", "", "", "", "", "", "", ""],
    // R1: subtitle
    [`Report Date: ${dateStr}  |  Data Source: ${clientName} Accident Cases Master File`, "", "", "", "", "", "", ""],
    // R2: spacer
    Array(8).fill(""),
    // R3: KPI section header
    ["KEY PERFORMANCE INDICATORS", "", "", "", "", "", "", ""],
    // R4: KPI labels
    [
      "Total Cases (All Time)", "Settled Cases", "In Process",
      "Overdue (>120d)", "Settlement Rate", "Avg Days Lapsed",
      "Total IDV Exposure", "Active Workshops",
    ],
    // R5: KPI values
    [total, settled, inProcess, overdue, `${settlePct}%`, `${avgDays}d`, totalIdvStr, activeWorkshops],
    // R6: spacer
    Array(8).fill(""),
    // R7: spacer
    Array(8).fill(""),
    // R8: section headers
    ["CASE CATEGORY BREAKDOWN", "", "", "", "", "STATUS BREAKDOWN", "", ""],
    // R9: sub-headers
    ["Category", "Count", "% of Total", "Distribution", "", "Status", "Count", ""],
    // R10+: data rows
    ...Array(numDataRows).fill(null).map((_, i) => {
      const [cat, catCnt] = catRows[i] || ["", ""];
      const [stat, statCnt] = statusRows[i] || ["", ""];
      const totalCats = catRows.reduce((s, [, n]) => s + n, 0);
      const pct = catCnt && totalCats ? Math.round((catCnt / totalCats) * 100) : 0;
      const barLen = catCnt ? Math.round((catCnt / totalCats) * 20) : 0;
      const bar = catCnt ? ("█".repeat(barLen) + "░".repeat(20 - barLen)) : "";
      return [
        cat,
        catCnt || "",
        catCnt ? `${pct}%` : "",
        bar,
        "",
        stat,
        statCnt || "",
        "",
      ];
    }),
    // spacer before insights
    Array(8).fill(""),
    // insights header
    ["💡  KEY INSIGHTS", "", "", "", "", "", "", ""],
    // insight rows
    [
      `• Settlement rate is ${settlePct}% — ${settlePct >= 70 ? "on track ✅" : "needs attention ⚠️"}`,
      "", "", "", "", "", "", "",
    ],
    [
      `• Average resolution time: ${avgDays} days per case`,
      "", "", "", "", "", "", "",
    ],
    [
      `• ${overdue} case${overdue !== 1 ? "s" : ""} overdue (${Math.round((overdue / Math.max(total, 1)) * 100)}% of portfolio)${overdue > 0 ? " — immediate follow-up required ⚠️" : " — portfolio healthy ✅"}`,
      "", "", "", "", "", "", "",
    ],
  ];

  const ws = XLS.utils.aoa_to_sheet(aoa);

  // ── Column widths ───────────────────────────────────────────────────────────
  ws["!cols"] = [
    { wch: 20 }, // col A — Category / Total Cases label
    { wch: 14 }, // col B — Settled / Count
    { wch: 14 }, // col C — In Process / % of Total
    { wch: 16 }, // col D — Overdue / Distribution bar
    { wch: 14  }, // col E — spacer (narrow)
    { wch: 22 }, // col F — Status ← wider to fit long status names
    { wch: 16 }, // col G — Count
    { wch: 14  }, // col H — spacer (narrow)
  ];

  // ── Row heights ─────────────────────────────────────────────────────────────
  ws["!rows"] = [
    { hpt: 28 }, // R0  title
    { hpt: 16 }, // R1  subtitle
    { hpt: 10 }, // R2  spacer
    { hpt: 20 }, // R3  KPI header
    { hpt: 22 }, // R4  KPI labels
    { hpt: 34 }, // R5  KPI values
    { hpt: 8  }, // R6  spacer
    { hpt: 8  }, // R7  spacer
    { hpt: 20 }, // R8  section headers
    { hpt: 20 }, // R9  sub-headers
    ...Array(numDataRows).fill({ hpt: 20 }),
    { hpt: 8  }, // spacer before insights
    { hpt: 20 }, // insights header
    { hpt: 18 }, // insight 1
    { hpt: 18 }, // insight 2
    { hpt: 18 }, // insight 3
  ];

  // ── Merges ──────────────────────────────────────────────────────────────────
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // title
    { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } }, // subtitle
    { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } }, // KPI header
    { s: { r: 8, c: 0 }, e: { r: 8, c: 3 } }, // category section header
    { s: { r: 8, c: 5 }, e: { r: 8, c: 7 } }, // status section header
    { s: { r: 9, c: 6 }, e: { r: 9, c: 7 } }, // "Count" header spans G+H
    ...Array(numDataRows).fill(null).map((_, i) => ({
    s: { r: 10 + i, c: 6 },
    e: { r: 10 + i, c: 7 },
  })),
    // insights
    { s: { r: insightBase,     c: 0 }, e: { r: insightBase,     c: 7 } },
    { s: { r: insightBase + 1, c: 0 }, e: { r: insightBase + 1, c: 7 } },
    { s: { r: insightBase + 2, c: 0 }, e: { r: insightBase + 2, c: 7 } },
    { s: { r: insightBase + 3, c: 0 }, e: { r: insightBase + 3, c: 7 } },
  ];

  // ── Styles ──────────────────────────────────────────────────────────────────

  // R0: title
  _sr(ws, 0, 0, 0, 7, {
    font: { bold: true, sz: 15, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "0D2137" } },
    alignment: { horizontal: "center", vertical: "center" },
  });

  // R1: subtitle
  _sr(ws, 1, 0, 1, 7, {
    font: { sz: 9, color: { rgb: "1A3A5C" } },
    fill: { fgColor: { rgb: "E8F4FD" } },
    alignment: { horizontal: "center", vertical: "center" },
  });

  // R3: KPI section header
  _sr(ws, 3, 0, 3, 7, {
    font: { bold: true, sz: 11, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1565C0" } },
    alignment: { horizontal: "center", vertical: "center" },
  });

  // R4: KPI label row
  const kpiColors = ["1565C0", "2E7D32", "E65100", "B71C1C", "1B5E20", "6A1B9A", "0D47A1", "00695C"];
  kpiColors.forEach((color, c) => {
    const addr = XLS.utils.encode_cell({ r: 4, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
    ws[addr].s = {
      font: { bold: false, sz: 8, italic: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: color } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: { top: THIN, left: THIN, right: THIN },
    };
  });

  // R5: KPI value row
  kpiColors.forEach((color, c) => {
    const addr = XLS.utils.encode_cell({ r: 5, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
    ws[addr].s = {
      font: { bold: true, sz: 18, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: color } },
      alignment: { horizontal: "center", vertical: "center" },
      border: { bottom: MEDIUM, left: THIN, right: THIN },
    };
  });

  // R8: section headers
  _sr(ws, 8, 0, 8, 3, {
    font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1565C0" } },
    alignment: { horizontal: "center", vertical: "center" },
  });
  _sr(ws, 8, 4, 8, 4, {
    fill: { fgColor: { rgb: "FFFFFF" } },
  });
  _sr(ws, 8, 5, 8, 7, {
    font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1565C0" } },
    alignment: { horizontal: "center", vertical: "center" },
  });

  // R9: sub-headers
  [0, 1, 2, 3, 5, 6, 7].forEach(c => {
    const addr = XLS.utils.encode_cell({ r: 9, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
    ws[addr].s = {
      font: { bold: true, sz: 9, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1A3A5C" } },
      alignment: { horizontal: "center", vertical: "center" },
      border: MEDIUM_BORDER,
    };
  });
  // spacer col 4 in sub-header row
  const subSpaceAddr = XLS.utils.encode_cell({ r: 9, c: 4 });
  if (!ws[subSpaceAddr]) ws[subSpaceAddr] = { v: "", t: "s" };
  ws[subSpaceAddr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };

  // R10+: data rows
  for (let i = 0; i < numDataRows; i++) {
    const r = 10 + i;
    const bg = i % 2 === 0 ? "EBF5FB" : "F8FBFF";

    // Category side — cols 0, 1, 2
    [0, 1, 2].forEach(c => {
      const addr = XLS.utils.encode_cell({ r, c });
      if (!ws[addr]) ws[addr] = { v: "", t: "s" };
      ws[addr].s = {
        font: { sz: 9, color: { rgb: "0D2137" } },
        fill: { fgColor: { rgb: bg } },
        alignment: { horizontal: c === 0 ? "left" : "center", vertical: "center" },
        border: THIN_BORDER,
      };
    });

    // Distribution bar — col 3
    const barAddr = XLS.utils.encode_cell({ r, c: 3 });
    if (!ws[barAddr]) ws[barAddr] = { v: "", t: "s" };
    ws[barAddr].s = {
      font: { sz: 7, color: { rgb: "1565C0" }, name: "Courier New" },
      fill: { fgColor: { rgb: bg } },
      alignment: { horizontal: "left", vertical: "center" },
      border: THIN_BORDER,
    };

    // Spacer col 4
    const spAddr = XLS.utils.encode_cell({ r, c: 4 });
    if (!ws[spAddr]) ws[spAddr] = { v: "", t: "s" };
    ws[spAddr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };

    // Status side — cols 5, 6
    const statusData = statusRows[i];
    const statusVal  = statusData ? statusData[0] : "";
    const statusBg   = statusVal
      ? /settled/i.test(statusVal)          ? "E8F5E9"
        : /critical|overdue/i.test(statusVal) ? "FDEDED"
        : /pending|process|progress/i.test(statusVal) ? "FFF3CD"
        : "FDEDED"
      : "FFFFFF";

    [5, 6].forEach(c => {
      const addr = XLS.utils.encode_cell({ r, c });
      if (!ws[addr]) ws[addr] = { v: "", t: "s" };
      ws[addr].s = {
        font: { bold: true, sz: 9, color: { rgb: "0D2137" } },
        fill: { fgColor: { rgb: statusBg } },
        alignment: { horizontal: c === 5 ? "left" : "center", vertical: "center" },
        border: THIN_BORDER,
      };
    });

    // Status left accent border based on status type
    const statusCellAddr = XLS.utils.encode_cell({ r, c: 5 });
    ws[statusCellAddr].s.border = {
      ...THIN_BORDER,
      left: {
        style: "medium",
        color: {
          rgb: /settled/i.test(statusVal) ? "2E7D32"
            : /critical|overdue/i.test(statusVal) ? "C62828"
            : "E65100",
        },
      },
    };

    // Spacer col 7
    const sp7Addr = XLS.utils.encode_cell({ r, c: 7 });
    if (!ws[sp7Addr]) ws[sp7Addr] = { v: "", t: "s" };
    ws[sp7Addr].s = { fill: { fgColor: { rgb: "FFFFFF" } },
      border: THIN_BORDER,
     };
  }

  // ── Insights section ────────────────────────────────────────────────────────

  // Spacer row before insights
  for (let c = 0; c < 8; c++) {
    const addr = XLS.utils.encode_cell({ r: insightBase - 1, c });
    if (!ws[addr]) ws[addr] = { v: "", t: "s" };
    ws[addr].s = { fill: { fgColor: { rgb: "FFFFFF" } } };
  }

  // Insights header
  _sr(ws, insightBase, 0, insightBase, 7, {
    font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1A3A5C" } },
    alignment: { horizontal: "left", vertical: "center" },
  });

  // Insight rows 1–3
  const insightStyles = [
    { bg: "E8F5E9", font: "1B5E20" },
    { bg: "FFF8E1", font: "E65100" },
    { bg: "FDEDED", font: "B71C1C" },
  ];
  insightStyles.forEach(({ bg, font }, idx) => {
    _sr(ws, insightBase + 1 + idx, 0, insightBase + 1 + idx, 7, {
      font: { sz: 9, color: { rgb: font } },
      fill: { fgColor: { rgb: bg } },
      alignment: { horizontal: "left", vertical: "center" },
      border: THIN_BORDER,
    });
  });

  XLS.utils.book_append_sheet(wb, ws, "Summary Dashboard");
}